import { initCloverTds, getBrowserInfo } from './utils/clover-utils';

/**
 * Unlike Paay/Cardinal, Clover doesn't expose submitTdsTransaction — its 3DS runs as a
 * post-payment action loop driven from services/pay.js. This factory just boots the SDK
 * singleton and hands back browser-info collection for the initial Create-a-Charge request.
 *
 * The Clover merchant UUID is the location's POS id (selectedLocation.pos.posLocationId),
 * passed in by the payment component — it is not carried on the gateway's threeDsConfig.
 */
const cloverService = ({ merchantUuid }) => {
  initCloverTds({ merchantUuid });

  return {
    getBrowserInfo
  };
};

export default cloverService;
